import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const AutoHeightImageWrapper = styled.div.withConfig({
  componentId: "sc-2zdrw-0"
})(["width:100%;position:relative;"]);
const AutoHeightImage = ({
  src,
  priority = false,
  imgLoadEvent = null,
  onError = null
}) => {
  return /*#__PURE__*/_jsx(AutoHeightImageWrapper, {
    children: src && /*#__PURE__*/_jsx(Image, {
      unoptimized: true,
      src: src,
      alt: "\uC774\uBBF8\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      width: 0,
      height: 0,
      sizes: "100vw",
      style: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain'
      },
      className: "autoImage",
      priority: priority,
      onLoadingComplete: e => {
        imgLoadEvent?.(e);
      },
      onError: onError
    })
  });
};
export default AutoHeightImage;